const en = {
  herosection: "Your digital Insurance platform",
  subscribeNow: "SUBSCRIBE NOW",
  addBeneficiary: "Savings plans",
  subscriptionNow: "Sign up !!",
  signUp: "Sign up",
  formInvalid: "Invalid form please check the information entered.",
  verifying: "Verification",
  verifyAccount: "Verify my account",
  beneficiaryInfo:
    "Please check and complete your details as the insured person, i.e. the person who will benefit from coverage in the event of hospitalization.Once you have completed this step, you can add the details of your beneficiary in the event of death, by clicking on the “Beneficiary” button.Please ensure that the information provided is accurate and up-to-date.",
  successfulInitiateSubsription:
    "Your subscription initiation has been successfully completed.",
  next: "Next",
  titreInscription: "Join the TechCare community",
  sousTitreInscription:
    "Become a member of an innovative community dedicated to savings and health insurance.",
  personalInformationMessage: "Fill in your details.",
  identificationMessage: "Fill in your identification details.",
  securityInformationMessage: "Secure your account with a 5-digit password.",
  information: "Personal Information",
  selectYouAccount: "Select your contract number to declare your insurance",
  completeYourInformationToAccessInsurance:
    "Please complete your profile information to access insurance features and services.",
  editInformation: "Edit Information",
  updateInformation: "Update Information",
  bronzeDescription:
    "Monthly premium: 500 FCFA \n Hospitalization: 75,000 FCFA \n Death: 125,000 FCFA \n The Bronze Package is designed for customers with lower savings. This package offers minimal protection, but remains an advantageous solution for those with a limited budget who still want basic coverage.",
  silverDescription:
    "Monthly premium: 800 FCFA \n Hospitalization: 120,000 FCFA \n Death: 200,000 FCFA \n The Silver Package is designed for customers with moderate savings. This package offers basic but sufficient coverage for hospitalization and death, at an affordable price.",
  goldDescription:
    "Monthly premium: FCFA 1,500 \n Hospitalization: FCFA 225,000 \n Death: FCFA 375,000 \n The Gold Package is designed for customers with average to high savings. This package offers good coverage for hospitalization and death, while being more affordable than the Platinium.",
  platinuimDescription:
    "Monthly premium: 2,000 FCFA \n Hospitalization: 300,000 FCFA \n Death: 500,000 FCFA \n The Platinium Package is designed for customers with substantial savings. This package offers maximum coverage for hospitalization and death, ensuring comprehensive protection and a high level of guarantee.",

  SelectAccount: "Select an insurance account",
  failedInitiateSubsription:
    "Your subscription initiation failed, please try again later.",
  addSubAccountDevice:
    "Please complete this form to register for TECHCARE 237 and take full advantage of our services.",
  Profil: "My account",
  insuranceID: "Phone Number",
  techCarePIN: "TechCare PIN",
  enterInsuranceID: "Enter Phone Number",
  enterPIN: "Enter PIN",
  userLoggedIn: "User Logged In successfully",
  invalidCredentials: "Invalid Credentials",
  loginError: "An error occurred during login",
  techcare_subtitle: "Your Digital Insurance platform",
  collaboration_text:
    "Fruit of the collaboration between Credixcam and SanlamAllianz, Covered by the insurer SanlamAllianz",
  readMore: "Read More",
  aboutUs: "About us",
  aboutTechCare: "We Provide Professional Insurance Services.",
  aboutTechCareDesc:
    "We offer comprehensive insurance solutions tailored to meet your unique needs. Our team of experts is dedicated to ensuring that you receive the best coverage at competitive rates. Trust us to protect what matters most to you with our reliable and professional services.",
  ourServices: "Our Services",
  hospitalizationInsurance: "Hospitalization Insurance",
  hospitalizationInsuranceDesc:
    "Our Hospitalization Insurance ensures that you are covered for any unexpected hospital stays. With plans designed to cater to your needs, you can have peace of mind knowing that your medical expenses are taken care of.",
  disabilityInsurance: "Disability Insurance",
  disabilityInsuranceDesc:
    "Protect your income with our Disability Insurance. In case of a disability that prevents you from working, our policy provides financial support to help you maintain your standard of living and cover essential expenses.",
  deathInsurance: "Death Insurance",
  deathInsuranceDesc:
    "Our Death Insurance offers financial security to your loved ones in the unfortunate event of your passing. Ensure that your family is protected and that their future is secure with our reliable insurance plans.",
  viewMore: "View More",
  whatClientsSay: "What Our Clients Say",
  contactUs: "Contact Us",
  phoneNumber: "Phone Number",
  message: "Message",
  send: "SEND",
  clientTestimonials: "Client Testimonials",
  clientFeedback1:
    "“This company provided excellent service and support during my insurance claims process. The staff were attentive and helped me through every step.”",
  clientFeedback2:
    "“I am extremely satisfied with the insurance policy I got. It was affordable and comprehensive. The customer service was outstanding.”",
  clientFeedback3:
    "“Their insurance coverage is second to none. I've been a customer for years and have always been impressed by their professionalism and efficiency.”",
  clientFeedback4:
    "“I highly recommend this insurance company. They offer great policies and their support team is very responsive and helpful.”",
  carouselPrev: "Previous",
  carouselNext: "Next",
  fillAllFields: "Please Check all required fields and try again",
  UserProfile: "User Profile",
  ClientDetails: "Information",
  Bulletin_dadhesion: "Profile",
  UploadPhoto: "Upload Photo",

  // completeSubscription:

  clientInfoFetched: "Client information fetched successfully",
  errorFindingClientInfo: "Error finding client information",
  clientUpdated: "Client information updated successfully",
  clientNotFound: "Client recovery failed",
  birthDay: "birthDay",
  enterFullName: "Enter your name and last name",
  parentInsuranceId: "Parent insurance ID",
  enterParentInsuranceId: "Enter your parent's insurance ID",
  selectNationality: "Select your nationality",
  english: "ENGLISH",
  idnumber: "Enter your card number",
  enterPhoneNumber: "Enter your phone number",
  enterPassword: "Enter your password",
  confirmPassword: "Confirm your password",
  french: "FRENCH",
  selectLanguage: "Select your language",
  idIssueDate: "ID issue date ",
  fullName: "First and last name",
  enterIdIssueDate: "Date of issue of ID card",
  idExpiryDate: "Expiry date of the CNI",
  enterIdExpiryDate: "Enter expiry date of the CNI",
  enterEmail: "exemple@gmail.com",
  idPlaceOfIssue: "Place of issue",
  enterIdPlaceOfIssue: "Enter place of issue CNI",
  password: "Password",
  editingFailed: "Editing failed",
  errorUpdatingClient: "Error updating client information",
  completionInProgress: "Completion in progress",
  subscriptionCompleted: "Subscription completed successfully",
  subscriptionFailed: "Subscription completion failed",
  beneficiaryAdded: "Beneficiary added successfully",
  checkDetailsAndTryAgain: "Check details and try again",
  failed: "Failed",
  loadingClientInfo: "Loading client information",
  completeSubscription: "My Account",
  addBeneficiaryAdvice: "If you have a beneficiary, please add their details.",
  enterRequiredInformation: "Required information",
  insuranceId: "Insurance ID",
  insuranceIdPlaceholder: "Enter Insurance ID",
  name: "Name & Surname",
  namePlaceholder: "Enter Name",
  nationality: "Nationality",
  nationalityPlaceholder: "Enter Nationality",
  phoneNumberPlaceholder: "Enter Phone Number",
  dateOfBirth: "Date of Birth",
  dateOfBirthPlaceholder: "Select Date of Birth",
  residence: "Residence",
  residencePlaceholder: "Enter Residence",
  nationalId: "National ID",
  nationalIdPlaceholder: "Enter National ID",
  cniIssueDate: "CNI Issue Date",
  cniExpiryDate: "CNI Expiry Date",
  cniIssueDatePlaceholder: "Select CNI Issue Date",
  cniExpiryDatePlaceholder: "Select CNI Expiry Date",
  cniPlaceOfIssue: "CNI Place of Issue",
  cniPlaceOfIssuePlaceholder: "Enter CNI Place of Issue",
  gender: "Gender",
  selectGender: "Select Gender",
  male: "Male",
  female: "Female",
  other: "Other",
  email: "Email",
  emailPlaceholder: "Enter Email",
  maritalStatus: "Marital Status",
  selectStatus: "Select Status",
  single: "Single",
  married: "Married",
  divorced: "Divorced",
  widowed: "Widowed",
  update: "Update User Information",
  complete: "Complete Subscription",
  relationship: "Relationship",
  relationshipPlaceholder: "Enter Relationship",
  occupation: "Occupation",
  occupationPlaceholder: "Enter Occupation",
  address: "Address",
  addressPlaceholder: "Enter Address",
  politicallyExposed: "Politically Exposed Person",
  selectOption: "Select Option",
  yes: "Yes",
  no: "No",
  close: "Close",
  saveChanges: "Save Changes",
  guardianName: "Guardian Name",
  guardianNamePlaceholder: "Enter Guardian Name",
  guardianRelationship: "Guardian Relationship",
  guardianRelationshipPlaceholder: "Enter Guardian Relationship",
  guardianPhoneNumber: "Guardian Phone Number",
  guardianPhoneNumberPlaceholder: "Enter Guardian Phone Number",
  guardianDateOfBirth: "Guardian Date of Birth",
  guardianInfo: "Beneficiary is a minor please enter Guardian Information",
  invalidDateGuardian:
    "Invalid date, Guardian cannot be less than 21 years old",
  invalidDateGuardian21:
    "Invalid date, Guardian cannot be less than 21 years old",
  PoliceTelephone: "Police Telephone Number",
  updateBeneficiary: "Update Beneficiary Information",
  father: "Father",
  mother: "Mother",
  spouse: "Spouse",
  child: "Child",
  brother: "Brother",
  sister: "Sister",
  userInfo: "User Information",
  DocumentStatus: "Document Status",

  // Beneficiary
  beneficiaryName: "Beneficiary Name",
  enterName: "Enter Name",
  relationshipWithBeneficiary: "Relationship with Beneficiary",
  selectRelationship: "Select Relationship",
  beneficiaryTelephoneNumber: "Beneficiary Telephone Number",
  enterTelephoneNumber: "Enter Telephone Number",
  beneficiaryDateOfBirth: "Beneficiary Date of Birth",
  noAvailableBeneficiary: "No Available Beneficiary",
  clientID: "Client ID",
  pleaseWait: "Please Wait...",
  Back: "Back",
  Benficiaryaddedsuccessfully:
    "Your registration from has been sent successfully",
  ifAffiled: "The number is already affiliated to an insurance package",
  days: "Days",
  Consulter: "Consult",
  titleConnect: "LOG ON TO",
  connexionDetail: "Enter your login details!",
  Benficiaryupdatedsuccessfully: "Beneficiary Updated successfully.",
  requiredField: "This field is required.",
  minimumCharacters: "This field must have at least 2 characters.",
  maximumCharacters: "This field must have no more than 50 characters.",
  invalidEmail: "Please enter a valid email address.",
  phoneNumberLength: "Phone number must be 12 digits long.",
  minimumAge: "You must be at least 18 years old.",
  maximumAge: "You must be less than 65 years old.",

  // NavBar
  home: "Home",
  about: "About",
  contact: "Contact",
  faq: "FAQ",
  signIn: "SIGN-IN",
  signOut: "SIGN-OUT",
  viewuserDetails: "View User details",
  nouser: "No User Connected",

  // Footer
  joinNewsletter:
    "Join Tech-Care newsletter to receive our best Insurance deals",
  unsubscribeAnytime: "You can unsubscribe at any time.",
  yourEmail: "Your Email",
  subscribe: "Subscribe",

  // Declaration

  Step1ConfirmInsuranceCode: "Step 1: Confirm Insurance Code",
  Step2Declaration: "Step 2: Declaration",
  Step3UploadClientNationalIDCard: "Step 3: Upload Client National ID Card",
  Step4UploadOtherClientDocuments: "Step 4: Upload Other Client Documents",
  InsuranceCode: "Insurance Code",
  SelectyourClaim: "Please select the type of claim",
  DOCUMENTSREQUIRED: "DOCUMENTS REQUIRED",
  UploadFrontViewofIDCard: "Upload Front View of ID Card",
  UploadBackViewofIDCard: "Upload Back View of ID Card",
  UploadOtherClientDocuments: "Upload Other Client Documents",
  Thankyou: "Thank you!",
  Thanksforconfirmingyoursubscription:
    "Thanks for confirming your subscription! We hope you have fun using our platform. If you ever need support, please feel free to email us at support@credixcm.com.",
  BacktoHomePage: "Back to HomePage",
  SelectClaim: "Select Claim",
  ViewClaims: "View Claim",
  conditionText:
    "I agree to the use of my data according to the TechCare237 terms and conditions",
  youMustAcceptTerms:
    "You must agree to the use of your personal data to complete your registration.",
  underageAge: "You must be over 18.",
  declaredDate: "Declared date",
  dateValidation: "Approval Date",
  NoClaimavailable: "No Claim available",
  SelectDoc: "Select Documents",
  NoDocumentavailable: "No Document available",
  Previous: "Previous",
  Next: "Next",
  Complete: "Complete",
  FrontViewID: "Front View",
  BackViewID: "Back View",
  UploadId: "Upload ID",
  UploadDoc: "Upload Document",
  IDCardPhotoUploadedSuccessfully: "ID Card Photo Uploaded Successfully",
  FailedIDCardPhotoUploadTryAgain: "Failed ID Card Photo Upload!!! Try Again",
  DocumentUploadedSuccessfully: "Document Uploaded Successfully",
  FailedDocumentTryAgain: "Failed Document!!! Try Again",
  confirmButton: "Confirm",
  ineligibleAccess: "Ineligible Access",
  notEligibleMessage:
    "You are not yet eligible to access the service. Please save first to become eligible.",
  goBackToHomepage: "Go back to Homepage",
  failedToCheckStatus: "No Status available",
  claims: "Claims",
  claimsDeclaration: "Make a claim",
  subscription: "Sign up",
  claimType: "CLAIM TYPE",
  document: "DOCUMENT",
  comment: "COMMENT",
  status: "STATUS",
  listOfClaims: "List of Claims",
  search: "Search",
  assue: "Insurance subscription",
  contact: "Our Contacts",
  nosPackages: "Our Insurance Packages",
  transactionButon: "Transaction history",
  declarationButton: "View my declarations",
  viewassue: "Consult my policyholder",
  infoAccount: "Account information",
  sousTitleEpargne: "Savings Plans",
  insufficientfound: "Save more to benefit from our insurance coverage !",
  titulaireAccount: "Owner's name",
  amountSave: "Amount saved",
  amountInterest: "Interest",
  typeEpargne: "(Free Saving)",
  titleEpargne1: "(Targeted savings)",
  amountCible: "(Target amount)",
  dateObjectif: "Date of target ",
  balance: "Balance",
  amountFrequency: "Contribution frequency",
  progression: "Objective progress",
  confirmPackage: "This package entitles you to health insurance coverage of",
  confirmPackage2: "and death of",
  transactionTitle: "Transaction history",
  lastTransaction: "Last transaction",
  notFrequence: "None Frequency",
  notObjectif: "No Objective",
  confirmPackage3:
    "Once chosen, the plan cannot be modified until the end of its validity.",
  assueButton: "View my assue",
  titleEpargne: "My Savings Accounts",
  backAccount: "Back to account",
  amount: "Amount",
  Statut: "Status",
  Envoyer: "Send",

  successEligile:
    "Congratulations! Your savings are eligible for insurance. Make your choice! ",
  pendingAssue:
    "Your application to join your insurance package is being validated.",
  insuredSuccess:
    "If you have already subscribed to an insurance package, you can no longer subscribe to another account.",
  beneficieInsurance:
    "You benefit from our insurance coverage. Thank you for your confidence!",

  addAssure: "Add Insured",
  declaration: "Declaration Of Claims",
  sinistre: "Claims",
  incorrectCredentials: "Incorrect credentials",
  failedToFindDocumentStatus: "Failed to find Document Status!!! Try Later",
  selectedRowsDeleted: "Selected rows deleted successfully",
  declareClaims: "Declare Claims",
  epargnes: "Our Insurance Offers",
  uploadEachDocumentIndividually: "Upload Each Document one by one",
  termeEtConditions: "Terms And Conditions",
  termeEtConditionsDes: "TERMS AND CONDITIONS",
  condition: "Our Terms and Conditions",
  passwordsDoNotMatch: "passwordsDoNotMatch",
  fileUploadGuidance:
    "Acceptable file types: PDF, JPG, PNG. Maximum file size: 5MB per file.",
  FileSizeExceeds5MB: "File size exceeds 5MB limit.",
  OnlyImageAndTextFilesAllowed: "Only image and text files are allowed",
  PleaseSelectAFile: "Please select a file to upload.",
  insuredInformation: "Beneficiary Décés Information",
  assureinfo: "Fill in the information of your hospitalization beneficiary",
  hideInsured: "Beneficiare",
  thankYouHeading: "Thank you!",
  thankYouMessage:
    "Thanks for submitting all necessary documents! We hope you have fun using our platform. If you ever need support, please feel free to email us at helpdeskcredixcm.com",
  pleaseSubscribe:
    "We appreciate your inquiry regarding declaration of a claim. However, based on our records, it appears that you have not subscribed to an insurance plan with us. Unfortunately, claims can only be processed for active insurance subscibed clients.",

  // About Page

  About: "About",
  AboutCredix: "Credixcam.sa",
  DescriptionAboutPlatinium: "Platinium",
  DescriptionAboutGold: "Gold",
  DescriptionAboutSilver: "Silver",
  DescriptionAboutBronze: "Bronze",
  AboutSanlam: "Sanlam | Allianz",
  AboutTechCare: "TechCare 237",
  CredixDescription:
    "Credix is a leading provider of financial services to individuals and businesses in Africa. Our mission is to provide access to financial services to millions of people, while creating jobs and driving economic growth. We are committed to building a community of engaged customers, partners, and employees who are passionate about making a difference in the lives of our customers.",
  ReadMore: "Read More",
  SanlamDescription:
    "Resulting from the merger between the Sanlam group, the pan-African leader in insurance, and the Allianz group, one of the world leaders in insurance, SanlamAllianz is the largest non-banking financial company.",
  SanlamDescriptionP2: "At SanlamAllianz, we protect people to",
  SanlamDescriptionPointOne:
    "Deal with the consequences of life's uncertainties (death, disability, hospitalization, etc.) through our insurance products and",
  SanlamDescriptionPointTwo:
    "Gently prepare for important projects through savings: retirement, estate planning, real estate purchase",
  TechCareDesc:
    "TechCare237 is an innovative platform that enables users to invest their money securely, while benefiting from life insurance. This solution aims to offer double added value: on the one hand, it enables customers to build up easily accessible savings, and on the other, it guarantees them health cover. TechCare237 users can use their savings to pay for medical care, while providing protection for their loved ones in the event of death, thanks to the life insurance clause included in the program.",
  TechCareDescP1:
    "By saving a minimum of 30,000 XAF for a year, many benefits are granted to our clients",
  TechCareDescPointOne: "An annual interest rate of XX%",
  TechCareDescPointTwo:
    "Financial protection for your loved ones in the event of death, Techcare 237 allows for a payout of 500,000 XAF to the designated beneficiary",
  TechCareDescPointThree:
    "Support of 10,000 XAF in case of hospitalization to ease the burden of medical expenses",
  decesInformation: "Death Beneficiary Information",
  lieuNaissance: "Place of birth",

    //Beneficiary
  EnterBeneficiaryName: "Please enter their last name",
  EnterBeneficiarySurName: "Please enter their first name",

  // FAQ

  FAQ: "FAQ",
  ClaimsDeclarationDescription:
    "In insurance terms, a claim is any material damage or bodily injury that brings into play the guarantees of the contract signed by the insurer and the insured. When an insurance policy is taken out, the insured is covered against various unexpected events, known as “claims”. For Techcare 237 products, claims include death, permanent and total disability and hospitalization.",
  AddBeneficiary: "BENEFICIARY",
  FrequentlyAskedQuestions: "Frequently Asked Questions",
  personnelInfo: "Personal information",
  hospiInfo: "Beneficiary information Hospitalization",
  ifAffiled: "Vous etes deja affilié a un package d'assurance",
  assuredInsurance: "you are insured",
  pendingInsurance: "Your request is being validated .....",
  Question1: "Claim",
  allStatus:"All Status",
  Question1Description:
    "A formal request made to the insurance provider by the policyholder to obtain compensation for a loss covered by the insurance contract.",
  Question2: "What is the purpose of the beneficiary clause in life insurance?",
  Question2Description:
    "The beneficiary clause in your life insurance serves to designate the person who will receive the capital upon your death. Thus, upon the death of the insured, the capital is paid to the beneficiary designated in the contract.",
  Question3: "Accident",
  Question3Description:
    "Any unintentional bodily injury resulting from the violent and sudden action of an external cause independent of the Insured's will.",
  Question4: "Insurer",
  Question4Description: "SANLAM LIFE INSURANCE CAMEROON.",
  Question5: "Insured or Member",
  Question5Description: "Person on whose life the insurance policy is based.",
  Question6: "Beneficiary",
  Question6Description:
    "Person entitled to receive the benefits provided in the contract in the event of the occurrence of the insured risk.",
  Question7: "Insured Capital or Guaranteed Capital",
  Question7Description:
    "Benefit due to the beneficiary by the Insurer upon the occurrence of the insured risk.",
  Question8: "CIMA Code",
  identitySection: "Piece of identification",
  Question8Description:
    "Insurance code of the member states of the Inter-African Conference of Insurance Markets (CIMA).",
  Question9: "Consolidation Date",
  Question9Description:
    "The date on which the insured's health condition has stabilized, and the consequences of the accident or illness become permanent and presumed definitive.",
  Question10: "Death",
  Question10Description: "Cessation of a person's life.",
  Question11: "Due Date",
  Question11Description: "Anniversary date of the contract.",
  Question12: "Nullity",
  Question12Description:
    "Sanction for the irregularity of an insurance contract. Nullity retroactively annuls the contract.",
  Question13: "Prescription",
  Question13Description:
    "Time limit set by law after which any action is declared inadmissible.",
  Question14: "Premium",
  Question14Description:
    "Price paid by the Subscriber in exchange for the guarantee offered by the Insurer.",
  Question15: "Termination",
  Question15Description:
    "Dissolution of a contract at the initiative of the Insurer or the Subscriber.",
  Question16: "Subscriber or Contractor",
  Question16Description:
    "Individual or legal entity that has entered into the insurance contract with the Insurer.",
  Question17: "Waiting Period",
  Question17Description:
    "Period of time between the effective date of the contract and the date from which the guarantees become effective (It is established to prevent abuse, fraud, and to hold policyholders accountable).",

  // CONTACT US

  ContactUs: "CONTACT US",
  ContactForm: "Contact Form",
  Name: "Name",
  EnterName: "Enter your name",
  nom: "Name",
  Email: "Email",
  SurName: "first name",
  Message: "Message",
  EnterMessage: "Enter your message",
  Submit: "Submit",
  ifAffiled: "If you are already insured, you cannot add another insured.",
  notInsured: "No policyholders at this time",
  notInsuredInfo: "Please add a policyholder to view information.",
  termeEtConditionsDes: "TechCare 237 General Terms and Conditions of Use",
  ClaimsDeclarationDescription:
    "In insurance terms, a Claim is any property damage or bodily injury that brings into play the guarantees of the contract signed by the insurer and the insured. When an insurance policy is taken out, the insured is covered against various unexpected events, known as Claims. For Techcare 237 products, Claims include death, permanent and total disability and hospitalization.",
  condition: "General terms and conditions",
  context: {
    title: "Contexte",
    description:
      "TechCare237 is an innovative platform that enables users to invest their money safely, while benefiting from life insurance. This solution aims to offer double added value: on the one hand, it enables customers to build up easily accessible savings, and on the other, it guarantees them health cover. TechCare237 users can use their savings to pay for medical care, while offering protection to their loved ones in the event of death, thanks to the life insurance clause included in the program. The platform is designed to be simple, flexible and accessible to all, including informal sector workers and small businesses, by integrating banking services and e-money operators. What's more, it complies with KYC standards to guarantee the security and transparency of transactions, while meeting the growing need for insurance and financial management.",
  },
  terms: {
    1: {
      title: "Subject",
      content:
        "Registration on the TECHCARE 237 platform implies full acceptance of these GCU by the customer. By subscribing, the customer acknowledges having read and accepted without reservation the conditions of use of the service.",
    },
    2: {
      title: "Membership and acceptance",
      content:
        "L’inscription à la plateforme TECHCARE 237 emporte acceptation pleine et entière des présentes CGU par le client. En souscrivant, le client reconnaît avoir pris connaissance et accepté sans réserve les conditions d'utilisation du service.",
    },
    3: {
      title: "Eligibility conditions",
      content:
        "To be eligible for TECHCARE 237 services, the customer must : <ul><li>Be a natural person aged at least 18;</li><li>Have a valid phone number linked to an active Mobile Money account (Orange or MTN);</li><li>Be resident in Cameroon;</li><li>Make regular savings via the TECHCARE 237 platform. </li></ul>",
    },
    4: {
      title: "How the service works",
      content: {
        4.1: {
          title: "Savings",
          content:
            "<ul><li>The minimum amount required to subscribe to the platform is set at 5,000 FCFA, partially refundable at 40%.</li> <li>In case of unsubscription, a closure fee of 3,000 FCFA is deducted from the subscription amount (5,000 FCFA), and the remaining balance is refunded to the customer, i.e., 2,000 FCFA.</li> <li>To close a savings account, the customer must first close all their savings plans.</li> <li>To unsubscribe from the platform, the customer must first close their savings plans, meaning withdrawing the money from all their savings plans.</li> <li>Two types of plans are available: <ul><li>Free savings with an interest rate of T1%.</li> <li>Goal-based savings with an interest rate of T2%.</li></ul></li> <li>A customer can create as many savings plans as they wish.</li> <li>A savings plan becomes active only after an initial deposit of at least 1,000 CFA via their electronic money account.</li> <li>The deposit amounts for savings plans range between 1,000 and 1,000,000 FCFA.</li> <li>If a customer chooses goal-based savings, they must first define the following elements: <ul><li>A savings goal (in FCFA) to achieve,</li> <li>A minimum deposit amount (minimum 1,000 FCFA),</li> <li>A deposit frequency (expressed in number of days).</li></ul></li></ul>",
        },
        4.2: {
          title: "Triggering insurance coverage",
          content:
            "When the amount saved by the customer reaches the threshold corresponding to one of the four (4) packages offered, and has remained in the account for at least 30 days, the customer becomes eligible for life insurance coverage underwritten by CREDIXCAM S.A. with an approved insurer.",
        },
      },
    },
    5: {
      title: "Description of insurance packages",
      content:
        "<table> <thead> <tr> <th>No.</th> <th>Package</th> <th>Minimum Savings</th> <th>Premium Paid by CREDIXCAM</th> <th>Hospitalization</th> <th>Funeral Expenses</th> </tr> </thead> <tbody> <tr> <td>1</td> <td>Bronze</td> <td>30,000 FCFA/month</td> <td>500 FCFA/month</td> <td>75,000/year*</td> <td>125,000 FCFA</td> </tr> <tr> <td>2</td> <td>Silver</td> <td>50,000 FCFA/month</td> <td>800 FCFA/month</td> <td>120,000 FCFA/year*</td> <td>200,000 FCFA</td> </tr> <tr> <td>3</td> <td>Gold</td> <td>75,000 FCFA/month</td> <td>1,500 FCFA/month</td> <td>225,000 FCFA/year*</td> <td>375,000 FCFA</td> </tr> <tr> <td>4</td> <td>Platinum</td> <td>100,000 FCFA/month</td> <td>2,000 FCFA/month</td> <td>300,000 FCFA/year*</td> <td>500,000 FCFA</td> </tr> </tbody> </table> <p>*Hospitalization: Maximum 30 days per year, capped at 15 days/month.</p>",
    },
    6: {
      title: "Duration of coverage",
      content:
        "The coverage takes effect 30 days after reaching the savings threshold and remains active as long as:<ul> <li>The customer's balance remains **equal to or above** the threshold of the chosen package;</li> <li>The customer **does not withdraw funds below the minimum threshold**;</li> <li>CREDIXCAM continues to pay the **monthly premium** to the insurer on behalf of the customer.</li> </ul>",
    },
    7: {
      title: "Withdrawal or loss of coverage",
      content:
        "<ul><li>No withdrawals from free savings are subject to the penalty.</li><li>Withdrawal before the target has been reached will incur a 5% penalty.</li><li>Withdrawals must be made at least 24 hours after the deposit (value date), and the available amount must be withdrawn in full.</li><li>All withdrawals are made from the customer's e-money account.</li><li>If no withdrawals are made at maturity, the Plan d'Epargne avec Objectif will automatically be reclassified as a Plan free saving. After this reclassification, the amounts saved will be subject to the current interest rate applicable to the Plan free saving.><li> Any withdrawal that causes the balance to fall below the insurance eligibility threshold automatically results in: <ul><li>La suspension ou la perte de la couverture d'assurance ;</li><li>L'impossibilité de bénéficier des prestations en cas de sinistre.</li></ul></li></ul>",
    },
    8: {
      title: "Rôle de CREDIXCAM",
      content:
        "CREDIXCAM agit en qualité de collecteur d’épargne et de souscripteur collectif pour l’assurance. Elle effectue, au nom et pour le compte du client, les versements mensuels de prime auprès de la compagnie d’assurance partenaire, selon les seuils atteints.",
    },
    9: {
      title: "Déclaration de sinistre",
      content:
        "En cas : <ul><li>D’hospitalisation, le client ou un proche doit transmettre les justificatifs à CREDIXCAM ou directement à l’assureur dans un délai de 7 jours ouvrables ;</li><li>De décès, les ayants droits doivent fournir un certificat de décès, une pièce d’identité valide et tout autre document exigé par l’assureur.</li></ul>",
    },
    10: {
      title: "Responsabilité",
      content:
        "CREDIXCAM S.A. ne saurait être tenue responsable : <ul><li>Du refus de prise en charge par l’assureur en cas de fausse déclaration ou dossier incomplet ;</li><li>De tout dysfonctionnement du réseau Mobile Money imputable aux opérateurs de téléphonie.</li></ul>",
    },
    11: {
      title: "Données personnelles",
      content:
        "Les données du client sont traitées conformément à la réglementation en vigueur sur la protection des données à caractère personnel. Elles sont utilisées uniquement dans le cadre de la gestion du service TECHCARE 237.",
    },
    12: {
      title: "Résiliation",
      content:
        "Le client peut à tout moment décider de se retirer de la plateforme, avec retrait de ses fonds. Toutefois, cela entraîne immédiatement l’arrêt des versements de primes d’assurance, et donc la résiliation automatique de sa couverture.",
    },
    13: {
      title: "Réclamations",
      content:
        "Toute réclamation doit être adressée au service client de CREDIXCAM par : <ul><li>E-mail : [Insérer l’e-mail]</li><li>Téléphone : [Insérer le numéro]</li><li>Ou à travers l’espace client sur la plateforme TECHCARE 237.</li></ul>",
    },
    14: {
      title: "Modification des conditions",
      content:
        "CREDIXCAM se réserve le droit de modifier à tout moment les présentes CGU. Les nouvelles conditions seront communiquées au client par tout moyen, notamment via SMS ou e-mail.",
    },
    15: {
      title: "Droit applicable et juridiction compétente",
      content:
        "Les présentes conditions sont régies par le droit camerounais. Tout litige relatif à leur interprétation ou exécution relève de la compétence exclusive des juridictions de Yaoundé, Cameroun.",
    },
  },
};

export default en;
